import { render, staticRenderFns } from "./article-tab.vue?vue&type=template&id=102c55a4&scoped=true&"
import script from "./article-tab.vue?vue&type=script&lang=js&"
export * from "./article-tab.vue?vue&type=script&lang=js&"
import style0 from "./article-tab.vue?vue&type=style&index=0&id=102c55a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102c55a4",
  null
  
)

export default component.exports